import { Reveal } from "@/components/Reveal";
import { AuditQuiz } from "@/components/pricing/AuditQuiz";

const Label = ({ children }) => (
  <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[var(--ember)]">
    {children}
  </span>
);

export default function Audit() {
  return (
    <section className="bg-[var(--bg-base)] pt-36 pb-24 md:pt-44 md:pb-32" data-testid="audit-page">
      <div className="mx-auto max-w-3xl px-6 md:px-12">
        <Reveal><Label>Free DNA audit</Label></Reveal>
        <Reveal delay={80}>
          <h1 className="mt-7 t-hero">
            Where should you start?
          </h1>
        </Reveal>
        <Reveal delay={160}>
          <p className="mt-4 text-base leading-relaxed text-[var(--muted)] sm:text-lg">
            Eight quick questions, then book your free Business DNA audit —
            we'll review your answers and come prepared.
          </p>
        </Reveal>
        <Reveal delay={220}>
          <div className="mt-10 rounded-3xl border border-black/5 bg-[var(--bg-contrast)] p-6 sm:p-10">
            <AuditQuiz />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
